export const GRANT_TYPE = 'password'
export const CLIENT_ID = 'customer-service'
